// Country / geo detection. Tries a free geo-IP service first, falls back to
// navigator.language, then to a hardcoded default (ES).

const STORAGE_KEY = "recomendalibros:country";
const DEFAULT = "ES";

const SUPPORTED = new Set([
    "ES", "MX", "AR", "CL", "CO", "PE", "UY", "VE",
    "US", "PT", "FR", "BE", "CH", "UK", "GB",
    "DE", "IT", "BR", "CA", "JP", "AU",
]);

function fromNavigator() {
    if (typeof navigator === "undefined") return null;
    const lang = navigator.language || (navigator.languages && navigator.languages[0]);
    if (!lang) return null;
    const match = lang.match(/-([A-Z]{2})/i);
    if (!match) return null;
    const code = match[1].toUpperCase();
    return SUPPORTED.has(code) ? code : null;
}

async function fromGeoJS() {
    try {
        const res = await fetch("https://get.geojs.io/v1/ip/country.json", {
            signal: AbortSignal.timeout ? AbortSignal.timeout(3000) : undefined,
        });
        if (!res.ok) return null;
        const data = await res.json();
        const code = (data.country || "").toUpperCase();
        return SUPPORTED.has(code) ? code : null;
    } catch {
        return null;
    }
}

export async function detectCountry() {
    try {
        const cached = localStorage.getItem(STORAGE_KEY);
        if (cached && SUPPORTED.has(cached)) return cached;
    } catch {
        /* ignore */
    }

    // Try geo-IP first (more accurate than navigator for VPN-free users)
    let code = await fromGeoJS();
    if (!code) code = fromNavigator();
    if (!code) code = DEFAULT;

    try {
        localStorage.setItem(STORAGE_KEY, code);
    } catch {
        /* ignore */
    }
    return code;
}

export function getCachedCountry() {
    try {
        const cached = localStorage.getItem(STORAGE_KEY);
        if (cached && SUPPORTED.has(cached)) return cached;
    } catch {
        /* ignore */
    }
    return DEFAULT;
}

export function setCountry(code) {
    const c = (code || "").toUpperCase();
    if (SUPPORTED.has(c)) {
        try {
            localStorage.setItem(STORAGE_KEY, c);
        } catch {
            /* ignore */
        }
        return c;
    }
    return null;
}

export const SUPPORTED_COUNTRIES = [
    { code: "ES", name: "Spain" },
    { code: "MX", name: "Mexico" },
    { code: "AR", name: "Argentina" },
    { code: "CO", name: "Colombia" },
    { code: "CL", name: "Chile" },
    { code: "PE", name: "Peru" },
    { code: "UY", name: "Uruguay" },
    { code: "VE", name: "Venezuela" },
    { code: "US", name: "United States" },
    { code: "PT", name: "Portugal" },
    { code: "FR", name: "France" },
    { code: "IT", name: "Italy" },
    { code: "DE", name: "Germany" },
    { code: "UK", name: "United Kingdom" },
    { code: "BR", name: "Brazil" },
    { code: "CA", name: "Canada" },
];
